module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/missioneDue.cf4f8c40.pdf";